import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import websocketClient from "../../../utils/websocketClient";
import { FaTimes } from "react-icons/fa";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SendInterestModal = ({ isOpen, onClose,postId,research_type, postOwnerId }) => {
  console.log("The post id is:",postId,research_type,postOwnerId)
  const [form, setForm] = useState({
    message: "",
    email: "",
    phone: "",
    file: null,
  });

  const [loading, setLoading] = useState(false); 

  if (!isOpen) return null;

 const handleChange = (e) => {
  const { name, value, files } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: name === "file" ? files[0] : value,
  }));
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    if(!postId)
    {
      toast.error("Post id required to send interest")
      return;
    }
    if(!research_type)
    {
      toast.error("Research type required to send interest")
      return;
    }
    if (!postOwnerId) {
      toast.error("Post owner information is missing. Cannot send interest.");
      return;
    }

    setLoading(true); // 👈 START LOADING

    try {
      const response = await axios.post(
        `${BASE_URL}/marketplace/researcher/interest/`,
        {
          ...form,
          to_user: postOwnerId,
          ...(
            research_type === 'opportunity' ? {opportunity :postId} : {labopportunity:postId}
          ),
        },
        {params:{
          filter_key : research_type === 'opportunity' ? "opportunity" : "labopportunity"
        }
        ,
         headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            "x-api-key": process.env.REACT_APP_X_API_KEY,
          },
      },
        
      );
     
        // const data = await response.json();
            if (response.status === 201) {
               alert("Interest sent successfully!");
                setForm({
    message: "",
    email: "",
    phone: "",
  });
              websocketClient.send(
                JSON.stringify({
                  event: "notifications",
                  type: "NEW_INTEREST_REQUEST",
                  recipientId: postOwnerId,
                  message: "You have a new iterest request",
                  payload: response.data,
                })
              );
                setTimeout(() => {
      // toast.success("Interest sent successfully!");
      onClose();
      setLoading(false);
    }, 3000)

            } else {
              console.error("Error sending request:", response.data);
            }
    } catch (error) {
       
      // toast.error(error?.response?.data?.error);
      if(error?.response?.status === 409)
      {
             alert(error?.response?.data?.error)
               onClose();
               setForm({
    message: "",
    email: "",
    phone: "",
  });
      }
      else
      {
              console.error("Error sending interest:", error);
      }
    } finally {
      setLoading(false); // 👈 STOP LOADING
    }
  };

  return (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
  <div className="bg-white rounded-2xl w-full max-w-2xl shadow-xl max-h-[90vh] overflow-y-auto">

    {/* Header */}
    <div className="flex items-center justify-between p-6 border-b border-gray-100">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-900">Send Interest</h2>
      </div>
      <button
        onClick={onClose}
        className="w-10 h-10 flex items-center justify-center rounded-xl hover:bg-gray-100 transition-colors"
        disabled={loading}
      >
        <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    {/* Form */}
    <form onSubmit={handleSubmit} className="p-6 space-y-5">

      {/* Interest Message */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Interest Message
        </label>
        <textarea
          name="message"
          placeholder="Why are you interested?"
          value={form.message}
          onChange={handleChange}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all resize-none"
          rows="4"
          required
          disabled={loading}
        />
      </div>

      {/* Email */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Email
        </label>
        <input
          type="email"
          name="email"
          placeholder="your@email.com"
          value={form.email}
          onChange={handleChange}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          required
          disabled={loading}
        />
      </div>

      {/* Phone */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          Phone <span className="text-gray-400 font-normal">(Optional)</span>
        </label>
        <input
          type="text"
          name="phone"
          placeholder="+1 234 567 8900"
          value={form.phone}
          onChange={handleChange}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
          disabled={loading}
        />
      </div>

      {/* Resume Upload */}
      <div>
        <label className="block text-sm font-semibold text-gray-700 mb-2">
          {form?.file ? "Uploaded File" : "Upload Resume (Optional)"}
        </label>

        {form?.file instanceof File ? (
          <div className="relative border border-gray-200 rounded-xl overflow-hidden">
            <button
              type="button"
              onClick={() => setForm((prev) => ({ ...prev, file: null }))}
              className="absolute top-2 right-2 w-8 h-8 bg-red-500 hover:bg-red-600 rounded-lg flex items-center justify-center z-10 transition-colors"
            >
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <iframe
              src={URL.createObjectURL(form.file)}
              className="w-full h-[200px]"
              title="Resume Preview"
            />
          </div>
        ) : (
          <label
            htmlFor="fileinput"
            className="flex flex-col items-center justify-center w-full h-32 border-2 border-dashed border-gray-300 rounded-xl cursor-pointer hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors"
          >
            <div className="flex flex-col items-center">
              <svg className="w-10 h-10 text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <p className="text-sm text-gray-500">Click to upload PDF</p>
            </div>
          </label>
        )}
        <input
          type="file"
          name="file"
          id="fileinput"
          accept=".pdf"
          hidden
          onChange={handleChange}
          disabled={loading}
        />
      </div>

      {/* Submit Button */}
      <button
        type="submit"
        disabled={loading}
        className="w-full py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {loading ? (
          <>
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            Sending...
          </>
        ) : (
          <>
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
            Submit Interest
          </>
        )}
      </button>

    </form>
  </div>
</div>
  );
};

export default SendInterestModal;